import { getShellLogger } from './logger'

const setContext = (prop: string, value?: string | number | boolean) => {
  try {
    getShellLogger().setContext(prop, value)
  } catch {
    // error accessing logger / setContext
  }
}

export const setShellLoggerContext = (...values: readonly (string | number | boolean)[]) => {
  const prop = 'shell'
  const valuesStr = values.reduce((str, value, i) => (i === 0 ? `${value}` : `${str}|${value}`), undefined)
  setContext(prop, valuesStr)
}
